import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router-dom';

import { router } from './router';
import { EnvironmentBanner } from './components/EnvironmentBanner';
import { GlobalToastViewport } from './components/GlobalToastViewport';
import { registerSW } from './utils/pwa';
import { offlineStorage } from './services/offlineStorage';
import { syncService } from './services/syncService';
import {
  installGlobalErrorCapture,
  installHubPageViewTracking,
} from './services/telemetry';
import './index.css';

// Usage telemetry: client JS errors (deduped, extension noise filtered) and
// hub page views. Both are fire-and-forget and can never break the app.
installGlobalErrorCapture();
installHubPageViewTracking(router);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

// Initialize offline services
async function initializeApp() {
  try {
    // Initialize IndexedDB
    await offlineStorage.init();
    console.log('Offline storage initialized');

    // Start background sync if online
    if (navigator.onLine) {
      syncService.startBackgroundSync();
    }

    // Clean up old offline data periodically
    offlineStorage.clearOldData(30);
  } catch (error) {
    console.error('Failed to initialize offline services:', error);
  }
}

// Register service worker
registerSW();

// Initialize app
initializeApp();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <EnvironmentBanner />
      <RouterProvider router={router} />
      <GlobalToastViewport />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
// Force rebuild Thu Jan 29 19:46:41 CST 2026
